/** 与后端 MarketTemplatePlayResolver.REGISTERED_STYLES 对齐 */
export const LOTTERY_PLAY_STYLES = new Set(['wheel', 'grid', 'scratch'])

export const PLAY_STYLE_LABELS: Record<string, string> = {
  wheel: '大转盘抽奖',
  grid: '九宫格抽奖',
  scratch: '刮刮乐',
  fission: '裂变引流',
  vote: '投票竞猜',
  quiz: '答题活动',
  signin: '签到活动'
}

export function playStyleLabel(style?: string): string {
  if (!style) return '营销活动'
  return PLAY_STYLE_LABELS[style] || style
}

export function isLotteryPlayStyle(style?: string): boolean {
  return !!style && LOTTERY_PLAY_STYLES.has(style)
}

export function playActionLabel(style?: string): string {
  if (style === 'scratch') return '刮奖'
  if (style === 'grid') return '抽奖'
  if (style === 'vote') return '投票'
  if (style === 'quiz') return '答题'
  if (style === 'signin') return '签到'
  if (style === 'fission') return '邀请'
  return '抽奖'
}
